import { price as priceUtil } from '@eti/utils';
import { ExpandableContent } from '@eti/components';
import { Text, textVariants } from '@etg/wings';
import { css, etiColors } from '@eti/styles';
import useId from '../hooks/useId';
import { useToggle } from '../../../common/custom-hooks/toggle';
import { CartRow, Price } from './CartComponents';
import { RowToggle } from './CartToggleableRow';

const listStyles = css`
  color: ${etiColors.grayScale[10]};
  display: flex;
  justify-content: space-between;
`;

const passContainerStyles = css`
  align-items: center;
  direction: ltr;
  display: inline-flex;
  gap: 3px;
  margin-inline-start: 10px;
`;

const passStyles = css`
  margin: 0;
`;

interface CartAvailability {
  airportList: string[];
  numberOfPass: number;
  passLabel: string;
}

interface CartFastTrackProps {
  dataTestId: string;
  title: string;
  price: number;
  availability: CartAvailability;
}

const CartFastTrack = ({ dataTestId, title, price, availability }: CartFastTrackProps) => {
  const { isOpen, handleToggle } = useToggle(false);
  const uniqueId = useId();
  const { airportList, numberOfPass, passLabel } = availability;

  return (
    <>
      <CartRow data-testid={dataTestId}>
        <RowToggle
          dataTestId={`${dataTestId}-toggle`}
          id={uniqueId}
          isExpanded={isOpen}
          onClick={handleToggle}
        >
          {title}
        </RowToggle>

        {price && <Price data-testid={`${dataTestId}-price`}>{priceUtil.formatPrice(price)}</Price>}
      </CartRow>

      <ExpandableContent isExpanded={airportList && isOpen}>
        <div>
          {airportList.map((row: string, index: number) => (
            <div
              className={listStyles}
              data-testid={`${dataTestId}-dataRow`}
              key={`subsection-${index}`}
            >
              <Text variant={textVariants._12}>{row}</Text>
              <div className={passContainerStyles}>
                <Text className={passStyles} variant={textVariants._12}>
                  {numberOfPass}
                </Text>
                <Text className={passStyles} variant={textVariants._12}>
                  {passLabel}
                </Text>
              </div>
            </div>
          ))}
        </div>
      </ExpandableContent>
    </>
  );
};

export default CartFastTrack;
